import { DatePipe } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { FX_DYNAMIC_TABULAR_CHAR_LIMIT_PER_CELL } from '../../dynamic-tabular.constants';

@Component({
  selector: 'fx-dynamic-tabular-table-cell',
  standalone: true,
  templateUrl: './dynamic-tabular-table-cell.component.html',
  imports: [DatePipe],
})
export class FxDynamicTabularTableCellComponent {
  public readonly CHAR_LIMIT_PER_CELL = FX_DYNAMIC_TABULAR_CHAR_LIMIT_PER_CELL;

  public readonly value = input.required<string>();

  public readonly isEditing = input<boolean>(false);

  public readonly columnType = input<'boolean' | 'date' | 'number' | 'text'>('text');

  public readonly readonly = input<boolean>(false);

  public readonly tabindex = input<string>('0');

  public readonly skipFormatting = input<boolean>(false);

  public readonly cellClick = output();

  public readonly cellBlur = output<string>();

  public readonly cellKeydown = output<KeyboardEvent>();

  public emitCellBlur(target: EventTarget | null): void {
    if (target instanceof HTMLInputElement) {
      this.cellBlur.emit(target.value);
    }

    if (target instanceof HTMLTextAreaElement) {
      this.cellBlur.emit(target.value);
    }

    if (target instanceof HTMLSelectElement) {
      this.cellBlur.emit(target.value);
    }
  }
}
